// 消费预测

import Vue from 'vue'
import request from '../request'

// 获取地区列表
export function getAreaNameList (params) {
    return request({
        url: Vue.prototype.baseURL + '/rubber/area-consume/getAreaNameList',
        method: 'GET',
        params
    })
}

// 消费预测 分页
export function forecastCostSelect (data) {
    return request({
        url: Vue.prototype.baseURL + '/rubber/area-consume/selectListByPage',
        method: 'POST',
        data
    })
}


// 消费预测 第三步
export function forecastConsume (params) {
    return request({
        url: Vue.prototype.baseURL + '/rubber/area-consume/forecastConsume',
        method: 'GET',
        params
    })
}


